// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectZone_wrapper__+TXOl","card":"SelectZone_card__ssmqG","arrowIcon":"SelectZone_arrowIcon__RaMJ3"};